// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getMobileBrowserOS } from '../../../redux/modules/browser';
import { getWhiteLabelName } from '../../../redux/modules/whiteLabel';
import { getWindowSize } from '../../../redux/modules/windowSize';
import WhiteLabelFooter from './WhiteLabelFooter';

type OwnProps = {||};

const mapStateToProps = state => {
    const { width: windowWidth } = getWindowSize(state);

    return {
        mobileBrowserOS: getMobileBrowserOS(state),
        whiteLabelName: getWhiteLabelName(state),
        windowWidth,
        year: new Date().getFullYear(),
    };
};

type ReduxProps = {|
    mobileBrowserOS: string,
    whiteLabelName: string,
    windowWidth: number,
    year: number,
|};

type Props = {|
    ...OwnProps,
    ...ReduxProps,
|};

class WhiteLabelFooterContainer extends PureComponent<Props> {
    render() {
        const { mobileBrowserOS, whiteLabelName, windowWidth, year } = this.props;

        return (
            <WhiteLabelFooter
                mobileBrowserOS={mobileBrowserOS}
                whiteLabelName={whiteLabelName}
                windowWidth={windowWidth}
                year={year}
            />
        );
    }
}

export default connect(mapStateToProps)(WhiteLabelFooterContainer);
